import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal-page-layout";
import { COMPANY, formatAddress } from "@/lib/company-info";

export const Route = createFileRoute("/yasal/kvkk")({
  head: () => ({
    meta: [
      { title: "KVKK & Gizlilik Politikası — JUËN" },
      { name: "description", content: "Kişisel verilerin korunması ve gizlilik politikası." },
      { property: "og:title", content: "KVKK & Gizlilik Politikası — JUËN" },
      { property: "og:description", content: "Kişisel verilerin korunması ve gizlilik politikası." },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <LegalPageLayout title="KVKK & Gizlilik Politikası" lastUpdated="01.05.2026">
      <h2>1. Veri Sorumlusu</h2>
      <p>
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca veri sorumlusu sıfatıyla
        hareket eden {COMPANY.legalName} ("Şirket"), kişisel verilerinizi aşağıda açıklanan
        kapsamda işlemektedir.
      </p>
      <ul>
        <li><strong>Adres:</strong> {formatAddress()}</li>
        
      </ul>

      <h2>2. İşlenen Kişisel Veriler</h2>
      <ul>
        <li><strong>Kimlik Bilgileri:</strong> ad, soyad, doğum tarihi</li>
        <li><strong>İletişim Bilgileri:</strong> e-posta, telefon numarası</li>
        <li><strong>Üyelik Bilgileri:</strong> üyelik durumu, üyelik geçmişi, puan bakiyesi</li>
        <li><strong>İşlem Bilgileri:</strong> sipariş geçmişi, bilet ve kupon kullanım kayıtları</li>
        <li><strong>Görsel Bilgiler:</strong> profil fotoğrafı (isteğe bağlı)</li>
        <li><strong>Teknik Bilgiler:</strong> IP adresi, cihaz bilgileri, çerez verileri, log kayıtları</li>
        <li><strong>Konum/Erişim:</strong> mekana giriş-çıkış kayıtları (QR kod okutma)</li>
      </ul>

      <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
      <ul>
        <li>Üyelik oluşturma, doğrulama ve yönetimi</li>
        <li>Etkinlik bileti, üyelik ve içecek kuponu satışı ve tesliminin gerçekleştirilmesi</li>
        <li>Mekana giriş kontrolü ve güvenliğinin sağlanması</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi (vergi, faturalama, mevzuat)</li>
        <li>Sipariş ve ödeme süreçlerinin yürütülmesi</li>
        <li>Müşteri hizmetleri ve şikayet yönetimi</li>
        <li>Açık rıza halinde pazarlama ve tanıtım faaliyetleri</li>
      </ul>

      <h2>4. Hukuki Sebepler</h2>
      <p>
        Kişisel verileriniz KVKK madde 5/2 kapsamında; sözleşmenin kurulması ve ifası, hukuki
        yükümlülüğün yerine getirilmesi, meşru menfaat ve gerektiğinde açık rıza hukuki
        sebeplerine dayalı olarak işlenmektedir.
      </p>

      <h2>5. Kişisel Verilerin Aktarılması</h2>
      <p>
        Kişisel verileriniz; ödeme hizmeti sağlayıcıları (Shopier vb.), bulut altyapı
        sağlayıcıları, e-posta gönderim servisleri, yetkili kamu kurum ve kuruluşları ile
        yasal zorunluluklar çerçevesinde paylaşılabilir. Verileriniz yurt içinde ve gerekli
        güvenlik tedbirleri alınmak kaydıyla yurt dışında bulunan altyapı sağlayıcılarda
        saklanabilir.
      </p>

      <h2>6. Veri Saklama Süresi</h2>
      <p>
        Kişisel verileriniz; ilgili mevzuatta öngörülen veya işleme amacının gerektirdiği
        süreler boyunca saklanır. Sürelerin sona ermesi halinde silinir, yok edilir veya
        anonim hale getirilir. Mali kayıtlar Vergi Usul Kanunu uyarınca asgari 5 yıl saklanır.
      </p>

      <h2>7. Çerez (Cookie) Politikası</h2>
      <p>
        Site, deneyiminizi geliştirmek ve oturum yönetimini sağlamak için zorunlu çerezler
        kullanır. Tarayıcı ayarlarınızdan çerezleri reddedebilirsiniz; ancak bu durumda Site'nin
        bazı özellikleri çalışmayabilir.
      </p>

      <h2>8. Veri Güvenliği</h2>
      <p>
        Kişisel verilerinizin güvenliği için SSL şifreleme, erişim kontrolleri, şifrelenmiş
        veri tabanı saklama, düzenli güvenlik denetimleri ve yetkilendirme katmanları
        uygulanmaktadır. Şifreleriniz tek yönlü hash algoritmaları ile saklanır; çalışanlarımız
        dahi açık şifrenize erişemez.
      </p>

      <h2>9. KVKK Madde 11 Kapsamındaki Haklarınız</h2>
      <p>İlgili kişi olarak Kanun'un 11. maddesi gereği aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme</li>
        <li>İşlenme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Yurt içinde/dışında aktarıldığı üçüncü kişileri bilme</li>
        <li>Eksik/yanlış işlenmişse düzeltilmesini isteme</li>
        <li>KVKK'nın 7. maddesi kapsamında silinmesini/yok edilmesini isteme</li>
        <li>Düzeltme/silme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
        <li>Otomatik sistemlerle analiz sonucu aleyhinize bir sonuç çıkmasına itiraz etme</li>
        <li>Hukuka aykırı işleme nedeniyle zarara uğramanız halinde tazminat talep etme</li>
      </ul>

      <h2>10. Başvuru Yöntemi</h2>
      <p>
        Yukarıdaki haklarınızı kullanmak için Şirket adresine bizzat veya noter
        aracılığıyla yazılı başvuruda bulunabilirsiniz. Başvurularınız en geç 30
        gün içinde sonuçlandırılır.
      </p>
    </LegalPageLayout>
  );
}
